import service from '@/utils/server';

const modName = '/plan/gps/';
//分页查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const fetchDetail = data => {
  return service({
    url: modName + 'fetchDetail',
    method: 'post',
    data
  });
};


export const synchSctDetail = data => {
  return service({
    url: modName + 'synchSctDetail',
    method: 'post',
    data
  });
};

export const driverGpsDetail = data => {
  return service({
    url: modName + 'driverGpsDetail',
    method: 'post',
    data
  });
};

// 切换小程序轨迹（sinoiov_gps_fetch_enabled 1 -> 0）
export const switchToWxGps = data => {
  return service({
    url: modName + 'switchToWxGps',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/log/TransportPlanFetchLog/api/index.js